import React from "react";

const SurveyLogo = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
        <svg
            width={size}
            style={style}
            height={size}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`${className || ""}`} 
        >
            <path
                d="M18.63 27.318a3.897 3.897 0 0 1-5.512-.05l-8.387-8.54a3.897 3.897 0 0 1 5.56-5.461l8.388 8.54a3.897 3.897 0 0 1-.05 5.51Z"
                fill="#FFA700"
            />
            <mask
                id="a"
                style={{
                    maskType: "alpha",
                }}
                maskUnits="userSpaceOnUse"
                x={3}
                y={12}
                width={17}
                height={17}
            >
                <rect
                    x={15.849}
                    y={30.049}
                    width={19.764}
                    height={7.794}
                    rx={3.897}
                    transform="rotate(-134.486 15.85 30.049)"
                    fill="#FFA700"
                />
            </mask>
            <g mask="url(#a)">
                <path
                    d="M8.354 22.529c2.746.293 6.27-2.129 7.724-3.446l-5.65 5.568-2.074-2.122Z"
                    fill="#007AFF"
                />
            </g>
            <path
                d="m10.442 24.543 16.94-16.518a3.897 3.897 0 1 1 5.442 5.58L18.74 27.337a3.992 3.992 0 0 1-5.645-.071l-2.654-2.723Z"
                fill="#007AFF"
            />
            <circle cx={16.705} cy={9.48} r={3.48} fill="#60B158" />
        </svg>
);

export default SurveyLogo;